import { useT } from '@/i18n'
import { cn } from '@/lib/cn'

/*
 * 像素加载：3×3 格子外圈 8 格，亮格顺时针一格一格跳。
 * 这里用 steps() 硬切是对的 —— 它本来就是在逐帧换图，没有「半亮」这种中间态；
 * 普通的悬停、展开仍然走缓动（alfaplus-hp 试过全站 steps()，读起来像掉帧）。
 * 颜色取 currentColor，调用方用 text-* 定。减弱动效时 8 格常亮、不转。
 */
const RING = [
  [0, 0],
  [1, 0],
  [2, 0],
  [2, 1],
  [2, 2],
  [1, 2],
  [0, 2],
  [0, 1],
] as const

export function PixelSpinner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 3 3"
      shapeRendering="crispEdges"
      fill="currentColor"
      aria-hidden
      className={cn('px-spinner inline-block size-6 shrink-0', className)}
    >
      {RING.map(([x, y], index) => (
        <rect
          key={index}
          x={x}
          y={y}
          width={1}
          height={1}
          style={{ animationDelay: `${(index - RING.length) * 100}ms` }}
        />
      ))}
    </svg>
  )
}

export function Spinner({ className }: { className?: string }) {
  const t = useT()
  return (
    <span role="status" aria-label={t('ui.loading')} className="inline-flex">
      <PixelSpinner className={cn('text-brand-ink', className)} />
    </span>
  )
}

export function CenteredSpinner({ label }: { label?: string }) {
  const t = useT()
  return (
    <div className="flex justify-center py-8" aria-live="polite">
      <Spinner />
      <span className="sr-only">{label ?? t('ui.loading')}</span>
    </div>
  )
}
